// import axios from 'axios';

// const api = axios.create({
//   baseURL: 'http://localhost:8000',
//   timeout: 10000,
// });

// // ==================== REQUEST INTERCEPTOR ====================
// api.interceptors.request.use((config) => {
//   // Attach JWT token if exists
//   const token = localStorage.getItem('access_token');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// // ==================== RESPONSE INTERCEPTOR ====================
// api.interceptors.response.use(
//   response => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Handle JWT token expiration
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const refreshToken = localStorage.getItem('refresh_token');
//         if (!refreshToken) throw new Error('No refresh token');

//         // Refresh JWT tokens
//         const { data } = await api.post('/api/token/refresh/', { 
//           refresh: refreshToken 
//         });

//         // Store new tokens
//         localStorage.setItem('access_token', data.access);
//         if (data.refresh) {
//           localStorage.setItem('refresh_token', data.refresh);
//         }

//         // Retry original request with new token
//         originalRequest.headers.Authorization = `Bearer ${data.access}`;
//         return api(originalRequest);
//       } catch (refreshError) {
//         // Clear tokens and redirect to login on refresh failure
//         localStorage.removeItem('access_token');
//         localStorage.removeItem('refresh_token');
//         window.location.href = '/login';
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// // API Client Methods
// const apiClient = {
//   // Auth - JWT only
//   login: (credentials) => api.post('/api/token/', credentials),
//   logout: () => {
//     localStorage.removeItem('access_token');
//     localStorage.removeItem('refresh_token');
//     return Promise.resolve(); // No server-side logout needed for JWT
//   },
//   getCurrentUser: () => api.get('/api/user/'),
  
//   // Token management
//   refreshToken: (refresh) => api.post('/api/token/refresh/', { refresh }),

//   // Products
//   getProducts: (search = '') => api.get(`/api/products/?search=${encodeURIComponent(search)}`),
//   addProduct: (productData) => api.post('/api/products/', productData),

//   // Orders
//   createOrder: (orderData) => apiClient.post('/api/orders/create_order', orderData),
//   getOrders: () => api.get('/api/orders/'),
//   getOrderDetails: (orderId) => api.get(`/api/orders/${orderId}/`)
// };

// export { apiClient };
// export default api;
// src/api.js
import axios from 'axios';

// ✅ Use environment variable with local fallback
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

console.log('🌐 API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// ==================== REQUEST INTERCEPTOR ====================
api.interceptors.request.use((config) => {
  // Attach JWT token if exists
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== RESPONSE INTERCEPTOR ====================
api.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle JWT token expiration
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) throw new Error('No refresh token');

        // Refresh JWT tokens - use absolute URL
        const { data } = await axios.post(
          `${API_BASE_URL}/api/token/refresh/`,
          { refresh: refreshToken }
        );

        // Store new tokens
        localStorage.setItem('access_token', data.access);
        if (data.refresh) {
          localStorage.setItem('refresh_token', data.refresh);
        }

        // Retry original request with new token
        originalRequest.headers.Authorization = `Bearer ${data.access}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Clear tokens and redirect to login on refresh failure
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// API Client Methods
const apiClient = {
  // Auth - JWT only
  login: (credentials) => api.post('/api/token/', credentials),
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    return Promise.resolve();
  },
  getCurrentUser: () => api.get('/api/user/'),
  
  // Token management
  refreshToken: (refresh) => api.post('/api/token/refresh/', { refresh }),

  // Products
  getProducts: (search = '') => api.get(`/api/products/?search=${encodeURIComponent(search)}`),
  addProduct: (productData) => api.post('/api/products/', productData),

  // Orders
  createOrder: (orderData) => api.post('/api/orders/create_order', orderData),
  getOrders: () => api.get('/api/orders/'),
  getOrderDetails: (orderId) => api.get(`/api/orders/${orderId}/`)
};

export { apiClient };
export default api;